<template>
  <div class="map" id="map" style="height: 500px; width: 100%;" ref="mapElement">
    <l-map ref="lmap" :zoom="zoom" :center="center">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-marker v-for="(marker, index) in markers" :lat-lng="marker.latlng" v-bind:key="'marker-' + index" @l-add="$event.target.openPopup()">
        <l-popup :content="marker.content"></l-popup>
      </l-marker>
      <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LPolyline, LMarker, LPopup } from 'vue2-leaflet'
import L from 'leaflet'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
// library to decode polyline to array of coordinates
let polyUtil = require('polyline-encoded')

export default {
  name: 'DailyPlanItemsMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline
  },
  computed: {
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    dailyPlanItems () {
      return this.initialDailyPlanItems.filter(item => !this.isItemMoved(item['@id']))
    }
  },
  props: {
    initialDailyPlanItems: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      map: null,
      zoom: 13,
      center: L.latLng(50.894489, 20.621944),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '<a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      bounds: [],
      markers: [],
      Locations: [],
      adresses: [],
      polyline: {
        color: 'green',
        latlngs: []
      },
      hints: {
        legs: [],
        totalDistance: '' // meters
      }
    }
  },
  mounted () {
    setTimeout(function () { window.dispatchEvent(new Event('resize')) }, 250)
  },
  watch: {
    'mapCenter' (val) {
      this.centerMap(this.Locations[val])
    },
    dailyPlanItems: {
      immediate: true,
      handler (val) {
        if (val) {
          this.setLocations()
        }
      }
    }
  },
  methods: {
    centerMap (location) {
      this.center = L.latLng(location.lat, location.lon)
    },
    async getRoute () {
      let waypoints = ''
      this.Locations.forEach((location, index) => {
        waypoints += location.lon + ',' + location.lat
        if (this.Locations[index + 1]) waypoints += ';'
      })
      try {
        const response = await fetch(`https://router.project-osrm.org/route/v1/driving/${waypoints}`)
        if (response.status !== 200) throw Error(await response.json())
        else {
          await response.json().then(data => {
            this.polyline.latlngs = polyUtil.decode(data.routes[0].geometry)
            data.routes[0].legs.forEach(leg => { this.hints.legs.push({ distance: leg.distance }) })
            this.hints.totalDistance = data.routes[0].distance
            this.hints.legs.forEach((leg, index) => {
              if (index === 0) {
                leg.from = data.waypoints[index].name
                leg.to = data.waypoints[index + 1].name
              } else {
                leg.from = data.waypoints[index].name
                leg.to = data.waypoints[index + 1].name
              }
            })
            this.$emit('routeRetrieved', this.hints)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getGeoLocation (params) {
      let response = await new ApiService('getlocalisationbyaddress', params).getResults()
      if (response.length > 0) {
        this.Locations.push(response[0])
      }
    },
    setMarkers () {
      let markersForBounds = []
      this.Locations.forEach((entry, index) => {
        this.markers.push({
          id: index,
          latlng: (L.latLng(entry.lat, entry.lon)),
          content: this.adresses[index]
        })
        markersForBounds.push(L.marker([entry.lat, entry.lon]))
      })
      let featureGroup = L.featureGroup(markersForBounds)
      this.$refs.lmap.fitBounds(featureGroup.getBounds())
      this.getRoute()
    },
    async setLocations () {
      if (this.dailyPlanItems.length > 0) {
        for (const entry of this.dailyPlanItems) {
          if (entry.task.idCase.idDevice && entry.task.idCase.idDevice.street) {
            let paramsAddress = {
              street: entry.task.idCase.idDevice.street,
              number: entry.task.idCase.idDevice.building,
              postcode: entry.task.idCase.idDevice.postcode,
              city: entry.task.idCase.idDevice.city
            }
            let address = (entry.task.idCase.idDevice.street.replace('ul', '') || '') + ' ' +
              (entry.task.idCase.idDevice.postcode || '') + ' ' +
              (entry.task.idCase.idDevice.city || '')
            this.adresses.push(address)
            await this.getGeoLocation(paramsAddress)
          } else {
            let paramsAddress = {
              street: entry.task.idCase.contractorUserData.street,
              number: entry.task.idCase.contractorUserData.streetNumber,
              postcode: entry.task.idCase.contractorUserData.postcode,
              city: entry.task.idCase.contractorUserData.city
            }
            let address = (entry.task.idCase.contractorUserData.street.replace('ul', '') || '') + ' ' +
              (entry.task.idCase.contractorUserData.streetNumber || '') + ' ' +
              (entry.task.idCase.contractorUserData.postcode || '') + ' ' +
              (entry.task.idCase.contractorUserData.city || '')
            this.adress = address
            this.adresses.push(address)
            await this.getGeoLocation(paramsAddress)
          }
        }
        this.setMarkers()
        this.centerMap(this.Locations[0])
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    isItemMoved (id) {
      let moveReason = this.initialDailyPlanItems.find(task => task['@id'] === id).moveReason
      return moveReason ? true : moveReason === ''
    }
  }
}
</script>
